export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
}

export const ERROR = {
    ERROR_403: "/403",
    get ERROR_403_PAGE() { return `${this.ERROR_403}`; },
}

export const USER_TYPE = {
    GUEST: "",
    ADMIN: '/admin',
    AGENT: '/agent',
    REGISTER:'/r'
}

export const NAVIGATE_CITIZEN = {
    HOME: '/',
    TERMS_CONDITIONS: '/terms-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    COPYRIGHT_POLICY: '/copyright-policy',
    DISCLAIMER: '/disclaimer',
    HYPERLINK_POLICY: '/hyperlink-policy',
}

export const NAVIGATE_REGISTER = {
    HOSPITAL_REGISTER: '/hospital/register',
    HOSPITAL_UPDATE: '/hospital/update',

    BLOOD_BANK_REGISTER:'/blood-bank/register',
    BLOOD_BANK_UPDATE:'/blood-bank/update',

    get HOSPITAL_REGISTER_PAGE() { return `${USER_TYPE.REGISTER}${this.HOSPITAL_REGISTER}`; },
    get HOSPITAL_UPDATE_PAGE() { return `${USER_TYPE.REGISTER}${this.HOSPITAL_UPDATE}`; },

    get BLOOD_BANK_REGISTER_PAGE() { return `${USER_TYPE.REGISTER}${this.BLOOD_BANK_REGISTER}`},
    get BLOOD_BANK_UPDATE_PAGE() { return `${USER_TYPE.REGISTER}${this.BLOOD_BANK_UPDATE}` }

}

export const NAVIGATE_ADMIN = {
    DASHBOARD: '/dashboard',
    HOSPITAL_LIST: '/hospitals',
    SCHEME_LIST: '/scheme-list',
    SEARCH_HOSPITALS: '/search-hospitals',
    SCHEME_HOSPITAL_LIST: '/scheme-list/hospitals',
    CALLS_DASHBOARD: '/calls',
    USER_LIST: '/user-list',
    BENEFICIARY_LIST: '/call-beneficiaries',
    BENEFICIARY_DETAILS: '/call-beneficiaries/details',
    WHATSAPP_VISITORS: '/whatsapp-visitors',
    BLOOD_BANK: '/blood-banks',
    PROFILE: '/profile',
    PROFILE_UPDATE: '/profile/update',

    get SCHEME_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.SCHEME_LIST}`; },
    get HOSPITAL_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.HOSPITAL_LIST}`; },
    get DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.DASHBOARD}`; },
    get SCHEME_HOSPITAL_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.SCHEME_HOSPITAL_LIST}`; },
    get SEARCH_HOSPITALS_PAGE() { return `${USER_TYPE.ADMIN}${this.SEARCH_HOSPITALS}`; },
    get CALLS_DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.CALLS_DASHBOARD}`; },
    get USER_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.USER_LIST}`; },
    get BENEFICIARY_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.BENEFICIARY_LIST}`; },
    get BENEFICIARY_DETAILS_PAGE() { return `${USER_TYPE.ADMIN}${this.BENEFICIARY_DETAILS}`; },

    get WHATSAPP_VISITORS_PAGE() { return `${USER_TYPE.ADMIN}${this.WHATSAPP_VISITORS}`; },
    get BLOOD_BANK_PAGE() { return `${USER_TYPE.ADMIN}${this.BLOOD_BANK}`; },
    get PROFILE_PAGE() { return `${USER_TYPE.ADMIN}${this.PROFILE}`; },
    get PROFILE_UPDATE_PAGE() { return `${USER_TYPE.ADMIN}${this.PROFILE_UPDATE}`; },
}

export const NAVIGATE_AGENT = {
    SEARCH_HOSPITALS: '/search-hospitals',
    CALLS_DASHBOARD: '/calls',
    BENEFICIARY_LIST: '/call-beneficiaries',
    BENEFICIARY_DETAILS: '/call-beneficiaries/details',

    get SEARCH_HOSPITALS_PAGE() { return `${USER_TYPE.AGENT}${this.SEARCH_HOSPITALS}`; },
    get CALLS_DASHBOARD_PAGE() { return `${USER_TYPE.AGENT}${this.CALLS_DASHBOARD}`; },
    get BENEFICIARY_LIST_PAGE() { return `${USER_TYPE.AGENT}${this.BENEFICIARY_LIST}`; },
    get BENEFICIARY_DETAILS_PAGE() { return `${USER_TYPE.AGENT}${this.BENEFICIARY_DETAILS}`; },
}

export const UserTypeWisePagesConfig: any = {
    admin: [
        NAVIGATE_ADMIN.HOSPITAL_LIST_PAGE, NAVIGATE_ADMIN.DASHBOARD_PAGE, NAVIGATE_ADMIN.SEARCH_HOSPITALS_PAGE, NAVIGATE_ADMIN.SCHEME_LIST_PAGE, NAVIGATE_ADMIN.SCHEME_HOSPITAL_LIST_PAGE,
        NAVIGATE_ADMIN.CALLS_DASHBOARD_PAGE, NAVIGATE_ADMIN.USER_LIST_PAGE, NAVIGATE_ADMIN.BENEFICIARY_LIST_PAGE, NAVIGATE_ADMIN.BENEFICIARY_DETAILS_PAGE, NAVIGATE_ADMIN.WHATSAPP_VISITORS_PAGE, NAVIGATE_ADMIN.BLOOD_BANK_PAGE
    ],
    agent: [NAVIGATE_AGENT.CALLS_DASHBOARD_PAGE, NAVIGATE_AGENT.SEARCH_HOSPITALS_PAGE, NAVIGATE_AGENT.BENEFICIARY_LIST_PAGE, NAVIGATE_AGENT.BENEFICIARY_DETAILS_PAGE],
    hospital: [NAVIGATE_ADMIN.PROFILE_PAGE, NAVIGATE_ADMIN.PROFILE_UPDATE_PAGE],
    blood_bank: [NAVIGATE_ADMIN.PROFILE_PAGE, NAVIGATE_ADMIN.PROFILE_UPDATE_PAGE],
}
